<template>
  <main class="bg-main">
    <section class="container md:px-12 sm:px-12 px-2 max-w-screen-2xl mx-auto mb-14">
      <div class="flex flex-col lg:flex-row gap-10 items-center">
        <!-- Value proposition image -->
        <div class="lg:w-1/2 mt-14 mb-8">
          <img
            src="../assets/images/val-prop.png"
            alt="About Barka U. Mshelia"
            class="w-full h-1/4 object-cover rounded-2xl"
          />
        </div>

        <!-- Value proposition content -->
        <div class="lg:w-1/2 lg:mt-14 mb-8 -mt-10">
          <h1 class="text-lg font-bold mt-8 lg:text-start text-[#ada595]">
            Value Proposition
          </h1>
          <div class="space-y-2 mt-8">
            <p class="text-left text-base text-white flex items-center mb-4">
              <i class="fa-brands fa-pushed text-[#ada595] mr-2 font-black"></i>
              Personalized & Ethical Mentorship
            </p>
            <p class="text-left text-base text-white flex items-center mb-4">
              <i class="fa-brands fa-pushed text-[#ada595] mr-2 font-black"></i>
              Wealth Creation & Management
            </p>
            <p class="text-left text-base text-white flex items-center mb-4">
              <i class="fa-brands fa-pushed text-[#ada595] mr-2 font-black"></i>
              Growth & Development
            </p>
            <p class="text-left text-base text-white flex items-center mb-4">
              <i class="fa-brands fa-pushed text-[#ada595] mr-2 font-black"></i>
              Investment Opportunities
            </p>
            <p class="text-left text-base text-white flex items-center mb-4">
              <i class="fa-brands fa-pushed text-[#ada595] mr-2 font-black"></i>
              Business Development & Strategy Advisory
            </p>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {};
</script>

<style scoped></style>
